import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ComingSoonComponent } from './components/coming-soon/coming-soon.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { CifCustomerComponent } from './components/cif-customer/cif-customer.component';
import { callcentercontent, content, gdccontent } from './shared-components/routes/routes';
import { ContentLayoutComponent } from './shared-components/content-layout/content-layout.component';
import { ContentLayoutGdcComponent } from './shared-components/content-layout-gdc/content-layout-gdc.component';
// import { DloginComponent } from './components/dealer/dlogin/dlogin.component';
import { ContentLayoutCallcenterComponent } from './shared-components/content-layout-callcenter/content-layout-callcenter.component';
import { PaymentStatusComponent } from './components/payment-status/payment-status.component';
import { PaymentTransactionStatusComponent } from './components/payment-transaction-status/payment-transaction-status.component';
import { DealerLoginComponent } from './dealer-login/dealer-login.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'fleetcare', component: DealerLoginComponent },
  { path: 'coming-soon', component: ComingSoonComponent },
  { path: 'order/payment-status', component: PaymentStatusComponent },
  { path: 'order/payment-transaction-status', component: PaymentTransactionStatusComponent },
  { path: 'customer-cif/:id', component: CifCustomerComponent },
  { path: '404', component: PageNotFoundComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: '',
    component: ContentLayoutComponent,
    children: content,
  },
  // {
  //   path: '',
  //   component: ContentLayoutComponent,
  //   children: admincontent,
  // },
  {
    path: '',
    component: ContentLayoutGdcComponent,
    children: gdccontent,
  },
  {
    path: '',
    component: ContentLayoutCallcenterComponent,
    children: callcentercontent,
  },
  // { path: 'dealer', loadChildren: () => import('./components/dealer/dealer.module').then(m => m.DealerModule) },
  // { 
  //   path: 'admin', 
  //   loadChildren: () => import('./components/admin/admin.module').then(m => m.AdminModule),
  //   data: {
  //     role: 'Admin'
  //   }
  //  },
  { path: '**', redirectTo: '/404' }
];
